export const crownpoint = {
    content: {
        line1: {
            header: "25 Baht = 1 Crown Point",
            description: "Earn 1 crown point for every 25 Baht spent for online and in-store. The crown point will be accumulated to redeem for special privileges and rewards offered from Burger King and our partners"
        },
        line2: {
            header: "Point Expiry = 1 Year",
            description: "Your point will be available for 1 year to redeem for special privilege. If you earned the points during January month, your points will expire by the end of January of next year. You can check Crown point balance at “My Point” menu"
        },
        line3: {
            header: "Points Cannot be Transferred",
            description: "Your crown points shall be deemed as personal property of the user only and cannot be transferred, offered or sold to other person, nor redeemed or exchanged for cash,</br>Points and rewards are not applicable at the airports, Jungceylon 1, Jungceylon 2, Bangla, Patong, Bangla-Patong, Samui, Samui Living Plaza, Otop Patong, Krabi, and Drive Thru and 1112 Call service"
        },
        line4: {
            header: "Service Together with Others",
            description: "You can use this service together with other promotions and is eligible for earning the Crown point in accordance with the actual amount spent after the deduction of any discount pursuant to the relevant promotion"
        },
        line5: {
            header: "Whopper Tiers",
            description: "For being such loyal customers of Burger King, you can now earn 4 different tiers.  Each tier have their own benefits and increasing benefit from tier to tier.  Crown points earned from your order will help you move the next tier.  Tier status are valid until the end of each quarter (31st of Mar, 30th of Jun, 30th of Sep, and 31st of Dec)."
        },
    },
    POINT: "Crowns",
    DOWNLOAD_APPLCICATION: "DOWNLOAD APPLICATION",
    Burger_King_Applications: "Burger King Thailand Applications",
};
